import { getDetailReview } from "@/api/endpoint/reviews/get-detail-reviews";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import ReviewInfo from "@/modules/common/ReviewDetail";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import HeaderDetail from "../ProjectDetail/HeaderDetail";
import HeaderDetailReview from "./HeaderDetailReview";
import { getReviewsReactions } from "@/api/endpoint/reviews/get-reviews-reactions";

const ReviewDetail = () => {
  const {
    query: { id },
  } = useRouter();
  const { userDataHeader } = useAuth();
  const {
    reviewDetail,
    setReviewDetail,
    project,
    projectListVote,
    setProjectListVote,
    listReviewsIds,
    listReviewReactions,
    setListReviewReactions
  } = useContext(ProjectContext);

  const handleGetListReviewsReactions = async () => {
    const res = await getReviewsReactions(listReviewsIds, userDataHeader);
    if (res) {
      setListReviewReactions([...listReviewReactions, ...res]);
    }
  };

  useEffect(() => {
    if (listReviewsIds?.length) {
      handleGetListReviewsReactions();
    }
  }, [listReviewsIds]);

  const getDetail = async () => {
    const res = await getDetailReview(id as string, userDataHeader);
    if (res) {
      setReviewDetail(res);
      setProjectListVote({
        ...projectListVote,
        results: res,
      });
    }
  };
  useEffect(() => {
    if (userDataHeader) {
      getDetail();
    }
  }, [userDataHeader]);
  return (
    <div className="bg-grey-100 min-h-[calc(100vh-77px)]">
      <HeaderDetail />
      <HeaderDetailReview project={project} />
      <div className="layout py-6">
        {reviewDetail ? <ReviewInfo reviewDetail={reviewDetail} /> : null}
      </div>
    </div>
  );
};

export default ReviewDetail;
